import $ from 'jquery';
import closeAllMenus from '../../core/INF-closeAllMenus';
import openModal from './openModal';

export default function() {
  // Do we need to close a modal?
  if ($('[data-modal].Modal--open').length > 0 && $('[data-modal].Modal--open').attr('id') !== window.location.hash) {
    closeAllMenus();
    $(document).trigger('scroll');
  }

  // Do we need to open a modal?
  // Also make sure the hash is alpha-numeric + underscore + hyphen, otherwise it's not a valid ID
  if (window.location.hash && window.location.hash !== '' && window.location.hash.replace('#', '').match('^[a-zA-Z0-9_-]*$')) {
    const $modal = $(`[data-modal]${window.location.hash}`);

    if ($modal.length > 0 && !$modal.hasClass('Modal--open')) {
      openModal($modal);
    }
  }
}